import styles from '../../assets/styles/Wallet/WalletQuickLinksCard.module.scss';
import { MimaButton, MimaText } from '../../components';
import { GiTakeMyMoney } from 'react-icons/gi';
import { FaPeopleArrows } from 'react-icons/fa';
import { IoIosSend } from 'react-icons/io';
import { RiDownloadCloudLine } from 'react-icons/ri';
import React from 'react';

const WalletQuickLinksCard = ({
	fundWallet,
	transfer,
	withdraw,
	urlSet,
	createBankAccount,
	hasBusinessAccount,
	viewBeneficiaries,
	virtualCard,
	viewStatement,
}) => {
	return (
		<div className={styles.wql}>
			<div className={styles.wql__title}>
				<MimaText variant="bodyBold">Quick Links</MimaText>
			</div>
			{/* {hasBusinessAccount === undefined ? <MimaButton title="Get Virtual Business Bank Account" onClick={createBankAccount} variant="form" mt={-2} /> : ""} */}
			<div className={styles.wql__links}>
				{/* <div className={styles.wql__links_item} onClick={fundWallet}>
					<FaMoneyBill />
					<MimaText variant="smallBold" align="center">Fund Wallet</MimaText>
				</div> */}
				<div className={styles.wql__links_item} onClick={transfer}>
					<IoIosSend />
					<MimaText variant="smallBold" align="center">
						Make Payment
					</MimaText>
				</div>
				<div className={styles.wql__links_item} onClick={withdraw}>
					<GiTakeMyMoney />
					<MimaText variant="smallBold" align="center">
						Withdraw
					</MimaText>
				</div>
				{/* <div className={styles.wql__links_item} onClick={virtualCard}>
					<MdOutlineCreditCard />
					<MimaText variant="smallBold" align="center">Dollar Card</MimaText>
				</div> */}
				<div className={styles.wql__links_item} onClick={viewBeneficiaries}>
					<FaPeopleArrows />
					<MimaText variant="smallBold" align="center">
						Beneficiaries
					</MimaText>
				</div>
				<div className={styles.wql__links_item} onClick={viewStatement}>
					<RiDownloadCloudLine />
					<MimaText variant="smallBold" align="center">
						Account Statement
					</MimaText>
				</div>
			</div>
		</div>
	);
};

export default WalletQuickLinksCard;
